import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { PracticeDTO, PracticeProxy } from 'src/app/shared/proxies';

@Injectable()
export class PracticeResolver implements Resolve<PracticeDTO> {
    constructor(private practiceProxy: PracticeProxy) {}

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PracticeDTO> {
        const practiceId = route.paramMap.get('practiceId');
        const practiceDTO = await this.practiceProxy.getPractice(practiceId);
        return practiceDTO;
    }
}
